import React, { useState } from "react";
import {
  Banner,
  Modal,
  Typography,
  Button,
  Radio,
  RadioGroup,
  DatePicker,
  Icon,
} from "@plum-xoxo/admin-dsm";
import styled from "styled-components";
import moment from "moment";

const getCustomIcon = () => {
  return <Icon iconName="PlumCalendar" color="dark" shade="c200" size="s" />;
};

const StyledTypography = styled(Typography).attrs()`
  display: inline-block;
  margin-bottom: 0;
`;
const DownloadPlumProHistoricalReport = ({
  downloadReport,
  employee_email = "",
  title,
}) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isRangeDownload, setIsRangeDownload] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  const startDateIsOutsideRange = (date) => {
    if (endDate) {
      if (endDate < date) {
        return true;
      }
    }
    if (moment(date) > new Date()) {
      return true;
    }
    return false;
  };

  const endDateIsOutsideRange = (date) => {
    if (startDate) {
      if (startDate > date) {
        return true;
      }
    }
    if (moment(date) > new Date()) {
      return true;
    }
    return false;
  };
  const handleDownload = () => {
    const filters = {
      is_historical: 1,
    };
    if (isRangeDownload) {
      const dateFormat = "YYYY-MM-DD";
      if (title === "xoxo reward code" || title === "xoxo reward points") {
        filters.generation_start_date = moment(startDate).format(dateFormat);
        filters.generation_end_date = moment(endDate).format(dateFormat);
      } else {
        filters.start_date = moment(startDate).format(dateFormat);
        filters.end_date = moment(endDate).format(dateFormat);
      }
    }
    downloadReport(filters, true);
    setShowPopup(false);
  };
  return (
    <div>
      <Banner
        className="mt-24"
        iconName="Info"
        description={
          <div>
            <StyledTypography color="dark" shade="c300">
              This table shows data for the last{" "}
              {title === "xoxo reward points" ||
              title === "xoxo reward code" ||
              title === "xoxo reward link"
                ? "twelve"
                : "six"}{" "}
              months. To download historical reports,{" "}
              <StyledTypography
                className="pl-4 cursor-pointer"
                color="primary"
                shade="c03"
                onClick={() => setShowPopup(true)}
                id="reports-download-historical-record-btn"
              >
                click here
              </StyledTypography>
            </StyledTypography>
          </div>
        }
      />
      <Modal
        isOpen={showPopup}
        onClose={() => {
          setShowPopup(false);
        }}
        disableCloseButton={false}
        size="md"
        style={{ width: "538px" }}
      >
        <Typography.H2 color="dark" shade="c300">
          Download Historical Reports
        </Typography.H2>
        <Typography color="dark" shade="c200">
          Choose from the options below. The reports will be emailed to{" "}
          {employee_email}.
        </Typography>
        <RadioGroup direction="column" className="mt-20">
          <Radio
            label="Download all available records"
            name="a"
            className="mb-24"
            checked={!isRangeDownload}
            onChange={() => {
              setIsRangeDownload(false);
            }}
          />
          <Radio
            label="Download records between"
            name="a"
            checked={isRangeDownload}
            onChange={() => {
              setIsRangeDownload(true);
            }}
          />
        </RadioGroup>
        <div className="d-flex ml-16 pl-24 mb-20">
          <div className="mr-16">
            <DatePicker
              inputFormat="dd/MM/yyyy"
              value={startDate}
              onChange={(value) => {
                setStartDate(value);
              }}
              shouldDisableDate={(day) => startDateIsOutsideRange(day)}
              defaultCalendarMonth={endDate ? new Date(endDate) : new Date()}
              disabled={!isRangeDownload}
              components={{
                OpenPickerIcon: getCustomIcon,
              }}
              placeholder="Start date"
            />
          </div>
          <div>
            <DatePicker
              inputFormat="dd/MM/yyyy"
              value={endDate}
              onChange={(value) => {
                setEndDate(value);
              }}
              shouldDisableDate={(day) => endDateIsOutsideRange(day)}
              defaultCalendarMonth={endDate ? new Date(endDate) : new Date()}
              disabled={!isRangeDownload}
              components={{
                OpenPickerIcon: getCustomIcon,
              }}
              placeholder="End Date"
            />
          </div>
        </div>
        <div className="d-flex">
          <Button
            color="primary"
            variant="plain"
            className="mr-12 ml-auto"
            onClick={() => {
              setShowPopup(false);
              setEndDate(null);
              setStartDate(null);
              setIsRangeDownload(0);
            }}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            variant="fill"
            disabled={
              !isRangeDownload ? false : startDate && endDate ? false : true
            }
            onClick={handleDownload}
          >
            Download
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default DownloadPlumProHistoricalReport;
